// トップページ専用 JS：シンプルなフェードオートプレイ・スライダー + リサイズ調整
document.addEventListener('DOMContentLoaded', () => {
  initSlider();
  initSlideResize();
  initScrollIndicator();
});

function initSlider() {
  const slider = document.getElementById('slider');
  if (!slider) return;
  const slides = Array.from(slider.children).filter((el) => el.classList.contains('slide'));
  if (slides.length === 0) return;

  // 1 枚目は relative で flow に乗せて #slider の高さを決め、
  // 2 枚目以降は absolute で重ねてフェード切り替え
  slides.forEach((slide, i) => {
    if (i === 0) {
      slide.style.position = 'relative';
    } else {
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
    }
    slide.style.opacity = i === 0 ? '1' : '0';
    slide.style.transition = 'opacity 1.2s ease';
  });
  slider.style.position = 'relative';
  slides[0].classList.add('active');

  let current = 0;
  setInterval(() => {
    const next = (current + 1) % slides.length;
    slides[current].style.opacity = '0';
    slides[current].classList.remove('active');
    slides[next].style.opacity = '1';
    slides[next].classList.add('active');
    current = next;
  }, 6000);
}

function initSlideResize() {
  const slide = document.getElementById('slide');
  if (!slide) return;
  const onResize = () => {
    const header = document.querySelector('header');
    const headerH = header ? header.offsetHeight : 0;
    const windowH = window.innerHeight;
    const windowW = window.innerWidth;
    const slideMaxH = (980 / 640) * windowW;
    const slideH = Math.min(windowH - headerH, slideMaxH);
    slide.setAttribute('data-full', String(slideH < slideMaxH));
    const isPortrait = windowH > windowW;
    const menuBtnVisible = window.getComputedStyle(document.getElementById('menu_btn') || document.createElement('div')).display !== 'none';
    if (isPortrait && menuBtnVisible) {
      slide.style.height = slideH + 'px';
    } else {
      slide.style.height = '';
    }
  };
  window.addEventListener('resize', onResize);
  onResize();
}

function initScrollIndicator() {
  // １度でもスクロールしたらインジケーターを消す
  const scroll = document.getElementById('scroll');
  if (!scroll) return;
  const onScroll = () => {
    scroll.style.transition = 'opacity 0.4s ease';
    scroll.style.opacity = '0';
    setTimeout(() => scroll.remove(), 400);
    window.removeEventListener('scroll', onScroll);
  };
  window.addEventListener('scroll', onScroll, { passive: true, once: true });
}
